import { apiClient } from "@/lib/api/axios";
import { env } from "@/lib/env";
import type { NotificationPage } from "../types";

export interface ListNotificationsParams {
  unread?: boolean;
  limit?: number;
  cursor?: string;
}

/**
 * Resolve o caminho de cada endpoint. Quando `VITE_NOTIFICATIONS_API_BASE_URL`
 * está definido, usa a URL ABSOLUTA do serviço central de notificações (que já
 * inclui `/v1`); o axios ignora `baseURL` para URLs absolutas, e o interceptor de
 * request continua anexando o Bearer token (ver `@/lib/api/axios`). Sem a base,
 * mantém o caminho relativo `/notifications...` (backoffice-api via
 * VITE_API_BASE_URL).
 */
const NOTIFICATIONS_BASE = env.VITE_NOTIFICATIONS_API_BASE_URL;

function url(path: string): string {
  return NOTIFICATIONS_BASE ? `${NOTIFICATIONS_BASE}${path}` : path;
}

/** Histórico persistido do admin (mais novas primeiro; cursor por id). */
export async function listNotifications(params?: ListNotificationsParams): Promise<NotificationPage> {
  const { data } = await apiClient.get<NotificationPage>(url("/notifications"), { params });
  return data;
}

/** Total de não lidas — usado pelo badge do sino sem carregar a lista. */
export async function getUnreadCount(): Promise<number> {
  const { data } = await apiClient.get<{ count: number }>(url("/notifications/unread-count"));
  return data.count;
}

export async function markNotificationRead(id: string): Promise<void> {
  await apiClient.post(url(`/notifications/${id}/read`));
}

export async function markAllNotificationsRead(): Promise<void> {
  await apiClient.post(url("/notifications/read-all"));
}

export async function deleteNotification(id: string): Promise<void> {
  await apiClient.delete(url(`/notifications/${id}`));
}
